import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

export class LayoutConfig {
  constructor(public expanded: boolean) {}
}

@Injectable()
export class LayoutService {
  public layoutSubject: BehaviorSubject<LayoutConfig>;
  public defaultConfig: LayoutConfig = {
    expanded: false,
  };

  constructor() {
    this.layoutSubject = new BehaviorSubject({ expanded: false, dense: false });
  }

  public getLayoutConfig(): Observable<LayoutConfig> {
    return this.layoutSubject;
  }
  public expandLayout(): void {
    const currentConfig = this.layoutSubject.getValue();
    this.layoutSubject.next({ ...currentConfig, expanded: true });
  }
  public minimizeLayout(): void {
    const currentConfig = this.layoutSubject.getValue();
    this.layoutSubject.next({ ...currentConfig, expanded: false });
  }

  public setDefault(): void {
    this.layoutSubject.next(this.defaultConfig);
  }
}

// expand for more layout features.
